import './DiagnosticStyles.css';
import React from "react";
import {GridColor} from "./Styles";

export const LEGEND_SHAPES = {
    BOX:'box',
    DASH:'dash',
    CIRCLE:'circle',
    DIAMOND:'diamond',
    SQUARE:'square'
}

const LineChartLegend = (props) =>{
    const {showAsCard = false, cardColor = GridColor.GREY, textShapeSpacing = 4, direction = 'vertical', dashAmount = 4, data = []} = props;

    let classes = 'line-chart-legend flexCentre',
        cardClass = '';

    if(showAsCard){
        cardClass = 'flex flexColumn ch-emph-block padding--l';
    }

    return(
        <>
            <div className={classes + (direction === 'vertical' ? ' legend-vertical' : ' margin-t--l')}>
                <div className={cardClass}>
                    <div className='flex flexCentre margin-b--l'>
                        <h4>Key</h4>
                    </div>
                    <div className={(direction === 'vertical' ? '' : 'legend-horizontal')}>
                        {data.map((entry, idx)=>{
                            const {shape = LEGEND_SHAPES.BOX, text, colors} = entry;
                            return(<div className="legend-item" key={idx}>
                                {shape === LEGEND_SHAPES.BOX &&
                                    <div>
                                        <div className={LEGEND_SHAPES.BOX+'Wrapper'} style={{gap:textShapeSpacing+'px'}} key={idx}>
                                            <div className={LEGEND_SHAPES.BOX} style={{backgroundColor:colors.background, borderColor:colors.border}} />
                                        </div>
                                        <div className="text">{text}</div>
                                    </div>
                                }
                                {shape === LEGEND_SHAPES.DASH &&
                                    <div style={{gap:textShapeSpacing+'px'}} key={idx}>
                                        <div className={LEGEND_SHAPES.DASH+'Wrapper'} style={{gap:'4px'}}>
                                            <div className={LEGEND_SHAPES.DASH} style={{backgroundColor:colors.background, borderColor:colors.border}}></div>
                                            <div className={LEGEND_SHAPES.DASH} style={{backgroundColor:colors.background, borderColor:colors.border}}></div>
                                            <div className={LEGEND_SHAPES.DASH} style={{backgroundColor:colors.background, borderColor:colors.border}}></div>
                                            <div className={LEGEND_SHAPES.DASH} style={{backgroundColor:colors.background, borderColor:colors.border}}></div>
                                        </div>
                                        <div className="text">{text}</div>
                                    </div>
                                }
                                {shape === LEGEND_SHAPES.CIRCLE &&
                                    <div className={LEGEND_SHAPES.CIRCLE+'Wrapper'} style={{gap:textShapeSpacing+'px'}} key={idx}>
                                        <div className={LEGEND_SHAPES.CIRCLE} style={{backgroundColor:colors.background, borderColor:colors.border}} />
                                        <div className="text">{text}</div>
                                    </div>
                                }
                                {shape === LEGEND_SHAPES.DIAMOND &&
                                    <div style={{gap:textShapeSpacing+'px'}} key={idx}>
                                        <svg width={24} height={24}>
                                            <mask id={'circleCut'}>
                                                <circle fill={'white'} cx={"12"} cy={"12"} r={"24"}></circle>
                                                <circle fill={'black'} cx={"12"} cy={"12"} r={"3"}></circle>
                                            </mask>
                                            <polygon mask={'url(#circleCut)'} points="3 12, 12 24, 21 12, 12 0" fill={colors.background} stroke={colors.border}/>
                                        </svg>
                                        <div className="text">{text}</div>
                                    </div>
                                }
                                {shape === LEGEND_SHAPES.SQUARE &&
                                    <div className={LEGEND_SHAPES.SQUARE+'Wrapper'} style={{gap:textShapeSpacing+'px'}} key={idx}>
                                        <div className={LEGEND_SHAPES.SQUARE} style={{backgroundColor:colors.background, borderColor:colors.border}} />
                                        <div className="text">{text}</div>
                                    </div>
                                }
                            </div>)
                        })}
                    </div>
                </div>
            </div>
        </>
    )

}

export default LineChartLegend;
